import React, { FC, useState } from 'react'
import Link from 'next/link'
import s from './Navbar.module.css'
import NavbarRoot from './NavbarRoot'
import { Logo, Container } from '@components/ui'
import { UserNav } from '@components/common'
import Drawer from 'rc-drawer'
import HamburgerMenu from 'react-hamburger-menu'
import { Accordion, Button } from '@components/ui'
import { useTranslations } from 'next-intl'
import useCustomer from '@framework/customer/use-customer'
import { I18nWidget } from '@components/common'
import { I18nWidgetSideNav } from '@components/common'
import { useRouter } from 'next/router'
import Cookies from 'js-cookie'
import Image from "next/legacy/image"

interface Link {
  href: string
  label: string
}

interface NavbarProps {
  settings?: any
  className?: any
  banner?: boolean
  colorDark?: string
  colorLight?: string
  coLogo?: any
}

const Navbar: FC<NavbarProps> = ({ settings = null, colorDark = null, colorLight = null, coLogo= null,  className = '', banner = false }) => {
  const mainNavigationItems = settings?.mainNavigation?.items
  const mainNavigationItemsBottom = settings?.mainNavigation?.bottomItems
  const [menuVisibile, setMenuVisibile] = useState(false)
  const { data: customer } = useCustomer()
  const t = useTranslations('Global')
  const toggleMenu = () => {
    setMenuVisibile(!menuVisibile)
  }
  const closeMenu = () => setMenuVisibile(false)

  const router = useRouter()

  if (router.query.dc) {
    try {
      Cookies.set('remiDiscountCode', router.query.dc)
    } catch (e) {
      console.error(e)
    }
  }

  // if(router.query.pid) {
  //   try {
  //     Cookies.set('pid', router.query.pid)
  //   }catch (e) {
  //     console.error(e)
  //   }
  // }

  if (router.query.awc) {
    try {
      Cookies.set('awc', router.query.awc)
    } catch (e) {
      console.error(e)
    }
  }

  if (router.query.ref) {
    try {
      Cookies.set('ref', router.query.ref)
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <>
      <NavbarRoot>
        {(!customer || banner) &&
          <div style={colorDark ? {
            backgroundColor: colorDark + '!important',
            color: 'var(--neutral900) !important'
          } : undefined} className={s.banner + ' bg-primary100 text-neutral700 text-center uppercase z-50 text-banner py-space3'}>
            <span className={'hidden sm:inline-block'}><span
              className={s.bannerIcon + ' icon-22-Package-22 text-icon22 align-middle mr-space2'}></span>{t('topBanner')}</span>
            <span className={'sm:hidden'}><span
              className={s.bannerIcon + ' icon-22-Package-22 text-icon22 align-middle mr-space2'}></span>{t('topBannerMobile')}</span>
          </div>
        }
        <Container className={`${className} ${customer ? '' : ''} sm:px-16`}>
          <div className={s.nav}>
            <div className='flex items-center flex-1 hamburgerMenu align-middle'>
              <HamburgerMenu
                isOpen={menuVisibile}
                menuClicked={toggleMenu}
                width={22}
                height={14}
                strokeWidth={2}
                rotate={0}
                color='#F4FFE0'
                borderRadius={11}
                animationDuration={0.5}
              />
              <div data-reamaze-lightbox='default'
                   className={'hidden lg:inline-block bg-transparent chatWrapper ml-space8 text-primary100 text-paragraph01'}>
                <i style={colorLight ? { backgroundColor: colorLight } : undefined} className={s.chatIcon}></i>
                Chat
              </div>
              <div className={'hidden lg:inline-block bg-transparent ml-space8 text-primary100'}>
                <I18nWidget />
              </div>
            </div>
            <div className='justify-center flex-1 h-16 flex items-center'>
              <Link href='/' className={'logo text-center w-full'} aria-label='Logo'>
                  {coLogo ?
                   <div className={'h-e107 w-full relative max-w-e287 inline-block'}>
                     <Image alt='Product hero image' priority={true} loading='eager'
                            src={coLogo} layout='fill' objectFit='contain' objectPosition={'center center'} />
                   </div>
                  :
                    <span
                      className={s.logo + ' icon-Logo-Remi text-primary100 lh-24 inline-block pt-2 text-logoMobile sm:text-logo'}></span>
                  }
              </Link>
            </div>
            <div className='flex items-center justify-end flex-1 space-x-8'>
              {/* B2B backlink to Remi Health — people googling "Remi" land
                  here (B2C) but often want the B2B page. Shown from md up;
                  mobile users get it via the menu. */}
              <a
                href='https://remihealth.com/?utm_source=myremi&utm_medium=backlink&utm_campaign=hero'
                target='_blank'
                rel='noreferrer'
                className='b2bLink hidden md:inline-block text-primary100 text-paragraph02 whitespace-nowrap hover:opacity-80 transition-opacity duration-200'
              >
                {t('forCompanies')}
              </a>
              <UserNav colorLight={colorLight}/>
            </div>
          </div>
        </Container>
      </NavbarRoot>
      <Drawer
        open={menuVisibile}
        onClose={toggleMenu}
        handler={false}
        level={null}
        className={s.drawer}
      >
        <button
          className={'w-e45 h-e45 inline-flex items-center justify-center ' + s.button + ' ' + (menuVisibile ? s.open : '')}>
          <HamburgerMenu
            isOpen={menuVisibile}
            menuClicked={toggleMenu}
            width={menuVisibile ? 24 : 18}
            height={menuVisibile ? 24 : 15}
            strokeWidth={2}
            rotate={0}
            color='#1c1c1c'
            borderRadius={0}
            animationDuration={0.5}
          />
        </button>
        {
          (mainNavigationItems || []).map((item: any) => {
            return (
              <div className='px-space6 md:px-space10 pb-8 pt-10' key={item._key}>
                <div className={'text-subheading font-medium text-neutral900 pb-2'}>
                  <span className={'pt-space2'}>{item.text}</span>
                </div>
                <nav className='pt-6 pb-4'>
                  {
                    item?.items?.map((subItem: any, index: number) => {
                      if ((!subItem.items || subItem?.items?.length === 0) && subItem?.active) {
                        return <a
                          rel='noreferrer'
                          target={subItem?.link?.externalUrl ? '_blank' : ''}
                          key={subItem._key}
                          className='text-paragraph02 md:text-subheading text-neutral900 block mt-4 md:hover:text-black40 transition-colors ease-in-out duration-300'
                          href={subItem?.link?.internalLink || subItem?.link?.externalUrl || '#'}
                        >{subItem.text}<span
                          className={index > 0 ? 'icon-CaretRight text-black20 float-right mr-2 align-middle text-subheading md:text-xl' : ''}></span></a>
                      }

                      return (
                        <div className='text-black text-left' key={subItem._key}>
                          {
                            subItem?.items?.map((subSubItem: any) => {
                              if (subSubItem.active) {
                                return (
                                  <Accordion
                                    key={subSubItem._key}
                                    title={subItem.text}
                                    toggleClassName='pb-0'
                                    showIndex={0}
                                  >
                                    <nav className='relative text-left z-10 pt-4'>
                                      {
                                        subItem?.items?.map((item: any) => (
                                          <a
                                            rel='noreferrer'
                                            target={item?.link?.externalUrl ? '_blank' : ''}
                                            key={item._key}
                                            href={item?.link?.internalLink || item?.link?.externalUrl || '#'}
                                            className={s.innerLink}
                                          >{item.text}</a>
                                        ))
                                      }
                                    </nav>
                                  </Accordion>
                                )
                              }
                            })
                          }
                        </div>
                      )
                    })
                  }
                  <div className={'border-t border-black20 border-solid pt-4 mt-4 lg:hidden'}>
                    <a
                      href={'/auth/login'}
                      className={'text-black text-paragraph02 md:text-subheading lg:text-heading03Mobile'}
                    ><span className={'icon-22-User-22 text-icon22 align-baseline mr-3'}></span>Log in</a>
                  </div>
                </nav>
              </div>
            )
          })
        }
        {(mainNavigationItemsBottom || []).map((item: any) => {
          return (
            <div key={item._key} className='absolute w-full bottom-6 md:bottom-10 left-6 md:left-10 items-center'>
              <div data-reamaze-lightbox='default' className={'lg:hidden bg-transparent chatWrapper text-black'}>
                <i style={colorLight ? { backgroundColor: colorLight } : undefined} className={s.chatIcon + ' ml-0'}></i>
                Chat
              </div>
              {
                item?.items?.map((subItem: any) => {
                  if (!subItem.items || subItem?.items?.length === 0) {
                    return <a
                      rel='noreferrer'
                      target={subItem?.link?.externalUrl ? '_blank' : ''}
                      key={subItem._key}
                      className=' text-black block mt-2 md:hover:text-black40 transition-colors ease-in-out duration-300'
                      href={subItem?.link?.internalLink || subItem?.link?.externalUrl || '#'}
                    >{subItem.text}</a>
                  }

                  return (
                    <div className='text-black text-left' key={subItem._key}>
                      {
                        subItem.items.map((subSubItem: any) => {
                          return (
                            <Accordion
                              key={subSubItem._key}
                              title={subItem.text}
                              toggleClassName='pb-0'
                              showIndex={0}
                            >
                              <nav className='relative text-left z-10 pt-2'>
                                {
                                  subItem?.items?.map((item: any) => (
                                    <a
                                      rel='noreferrer'
                                      target={item?.link?.externalUrl ? '_blank' : ''}
                                      key={item._key}
                                      href={item?.link?.internalLink || item?.link?.externalUrl || '#'}
                                      className={s.innerLink + ' block'}
                                    >{item.text}</a>
                                  ))
                                }
                              </nav>
                            </Accordion>
                          )
                        })
                      }
                    </div>
                  )
                })
              }
              <div className={'mt-4 lg:mt-0 lg:hidden'}>
                <div className={'inline-block bg-transparent text-black'}>
                  <I18nWidgetSideNav />
                </div>
              </div>
            </div>
          )
        })
        }
      </Drawer>
    </>
  )
}

export default Navbar
